<script>
  import moment from 'moment';
</script>
<footer class="footer">
  <div class="d-sm-flex justify-content-center justify-content-sm-between">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © {moment().year()} <a href="https://softlinedata.com/" target="_blank">Softline Data</a>. All rights reserved.</span>
  </div>
</footer>